import React from 'react'
import './DateArea.scss'
import {Grid, Box} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import ErrorIcon from '@material-ui/icons/ErrorOutline'
import _ from 'lodash'

export default function PendingInfoDesign({
  state,
  status,
  approveClick,
  rejectClick,
  reservationDone,
}) {
  return (
    <>
      <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
        <div style={{display: '-webkit-inline-box', marginTop: '10px'}}>
          {!rejectClick && !approveClick && reservationDone >= 0 && (
            <div
              className="reservation-bookings-info-area__outer-circle"
              style={{
                backgroundColor: rejectClick ? '#ff2020' : '',
                borderColor: rejectClick ? '#ff2020' : '',
              }}
            >
              <div className="reservation-bookings-info-area__inner-circle" />
            </div>
          )}
          {reservationDone < 0 && (
            <ErrorIcon
              style={{
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                border: '0px solid #edc43e',
                color: 'white',
                backgroundColor: '#edc43e',
                marginRight: '8px',
              }}
            />
          )}
          {rejectClick && (
            <ClearIcon
              style={{
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                border: '1px solid #ff2020',
                color: 'white',
                backgroundColor: '#ff2020',
                marginRight: '8px',
              }}
            />
          )}
          {approveClick && (
            <CheckIcon
              style={{
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                border: '1px solid #3473ff',
                color: 'white',
                backgroundColor: '#3473ff',
                marginRight: '8px',
              }}
            />
          )}
          {status}&nbsp;
          {!rejectClick && !approveClick && reservationDone >= 0 && (
            <Box color="#1d2331">{`- ${state}`}</Box>
          )}
          {reservationDone < 0 && <Box color="#1d2331">- No Response</Box>}
          {rejectClick && reservationDone >= 0 && <Box color="#1d2331">- Rejected</Box>}
          {approveClick && reservationDone >= 0 && <Box color="#1d2331">- Approved</Box>}
        </div>
      </div>
      <div className="reservation-bookings-info-area__vertical-line" />
      <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
        <div style={{display: '-webkit-inline-box', marginTop: '2px', color: '#acb0ba'}}>
          <div
            className="reservation-bookings-info-area__outer-circle"
            style={{border: '8px solid #eaebee'}}
          />
          Upcoming
        </div>
      </div>
      <div className="reservation-bookings-info-area__vertical-line" />
      <div style={{fontSize: '14px', textTransform: 'capitalize', marginBottom: '34px'}}>
        <div style={{display: '-webkit-inline-box', marginTop: '2px', color: '#acb0ba'}}>
          <div
            className="reservation-bookings-info-area__outer-circle"
            style={{border: '8px solid #eaebee'}}
          />
          Fulfilled
        </div>
      </div>
    </>
  )
}
